export default __webpack_public_path__ + "static/media/wine.7d138a50.jpg";